export default {
    settings: [],
    currentSetting: {},
    resolves:[],
    loading: false,
    paymentSystems: [
        {id: 1, name: 'Appex', label: 'Аппекс'},
        {id: 2, name: 'PayTravel', label: 'Pay Travel'},
        {id: 3, name: 'PayOnline', label: 'Pay Online (эквайринг и СБП)'},
        {id: 4, name: 'Uniteller', label: 'Uniteller'},
        {id: 5, name: 'PayKeeper', label: 'Pay Keeper'},
        {id: 6, name: 'Payler', label: 'Payler'},
        {id: 7, name: 'Открытие', label: 'Открытие (терминалы)'},
        {id: 8, name: 'AlfaBank', label: 'Альфа Банк (эквайринг и СБП)'},
        {id: 9, name: 'Qiwi', label: 'Qiwi (эквайринг и СБП)'},
        {id: 10, name: 'Subsidy', label: 'Оплата дотациями'},
        {id: 11, name: 'Tinkoff', label: 'Тинькофф Банк (эквайринг и СБП)'},
        {id: 12, name: 'CloudPayments', label: 'Cloud Payments'},
        {id: 13, name: 'StaticQr', label: 'Статический QR код'},
        {id: 14, name: 'Sberbank', label: 'Сбербанк (эквайринг и СБП)'},
        ]
}
